import { PersonsReportingsService_reportingServiceGetEntities } from '@festina/life-general-types/life/hooks/PersonsReportingsService_reportingServiceGetEntities'

export const useFetchPersonsReportingsNoSuspense =
  PersonsReportingsService_reportingServiceGetEntities.useQuery
